<form [formGroup]="addGuidelineForm" (ngSubmit)="addGuideline()">
  <div class="row">
    <div class="form-group col-md-8">
      <label>Title <span class="text-danger small">(required)</span></label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addGuidelineForm, 'title')"
        formControlName="title" placeholder="Title" required>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-8">
      <label>URL <span class="text-danger small">(required)</span></label>
      <input type="url" class="form-control" [ngClass]="setClassInvalid(addGuidelineForm, 'url')"
        formControlName="url" [pattern]="urlRegexp" placeholder="https://example.com" required>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-8">
        <label>Department <span class="text-danger small">(required)</span></label>
        <select class="form-control" [ngClass]="setClassInvalid(addGuidelineForm, 'department')"
          formControlName="department" required>
        <option value="" selected>Select department</option>
        @for (department of guidelineDepartments; track department) {
          <option [value]="department">{{department}}</option>
        }
      </select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-8">
      <label>Pinned</label>
      <select class="form-control" [ngClass]="setClassInvalid(addGuidelineForm, 'pinned')"
        formControlName="pinned" required>
        <option [value]="" disabled>Select pinned</option>
        <option [value]="true">Yes</option>
        <option [value]="false" selected>No</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <button class="btn btn-primary" type="submit" [disabled]="!addGuidelineForm.valid">
        <i class="fa fa-user-plus"></i> Add document
      </button>
    </div>
  </div>
</form>